<template>
  <div class="image-content-root" :style="areaStyle">
    <div v-show="hotZoneList" v-for="(zone, index) in hotZoneList" :key="index" :style="{
      position: 'absolute',
      zIndex: 10,
      top: zone.topPer * 100 + '%',
      left: zone.leftPer * 100 + '%',
      width: zone.widthPer * 100 + '%',
      height: zone.heightPer * 100 + '%'
    }" @click="jumpUrl(zone)"></div>
    <div class="picture-article-container"
         @click="jumpUrl(specialEntry)"
    >
        <img class="picture-article-img" :style="pictureStyle" v-if="pictureBg" :src="pictureBg" alt="">
    </div>
  </div>
</template>
<script>
import {commonClickFn} from './clickJs'
import api from '../../api/index'
// import share from "./share";
export default {
  name: "imageContent",
  data() {
    const { tempData: {specialStyle, specialEntry} } = this.data
    return {
      specialStyle,
      specialEntry,
      pictureBg: specialEntry?.entryImg || 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/09/1631584207647.jpg',
      hotZoneList: specialEntry?.hotZoneList || []
    }
  },
  props: {
    data: {
      type: Object
    },
  },
  computed: {

    coverImg() {
      const {
        maskColor,
      } = this.specialStyle;
      return {
        backgroundColor: maskColor ? maskColor : 'none',
      }
    },

    areaStyle() {
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor,
      } = this.specialStyle;
      return blockMargeBottom ? 
      {
        marginTop: `${blockMargeTop ? blockMargeTop : 0}px`,
        marginBottom: `${blockMargeBottom}px`,
        backgroundColor: blockBGClolor ? blockBGClolor : 'none',
        position: 'relative'
      } : {
        marginTop: `${blockMargeTop ? blockMargeTop : 0}px`,
        backgroundColor: blockBGClolor ? blockBGClolor : 'none',
        position: 'relative'
      }
    },
    pictureStyle() {
      const {
        imgRadius,
        imgShadow,
        imgBorder,
        imgBackgroundColor = '',
      } = this.specialStyle;
      return {
        backgroundColor: imgBackgroundColor ? imgBackgroundColor : '',
        borderRadius: imgRadius ? '4px' : '',
        boxShadow: imgShadow ? '0px 0px 8px 0px rgba(0, 0, 0, 0.1)' : '',
        border: imgBorder ? `1px solid #D6DEEA` : 'none',
      }
    },


    titleStyle() {
      const {
        titleSize,
        titleColor,
        titleBold = false,
        titleAlign
      } = this.specialStyle;
      return {
        fontSize: `${titleSize ? titleSize : 16}px`,
        color: titleColor,
        fontWeight: `${titleBold ? 'bold' : ''}`,
        textAlign: titleAlign ? titleAlign : 'center',
      }
    },
    contentStyle() {
      const {
        descSize,
        descColor,
        descBold = false,
        descAlign
      } = this.specialStyle;
      return {
        fontSize: `${descSize ? descSize : 12}px`,
        color: descColor ? descColor : '',
        fontWeight: `${descBold ? 'bold' : ''}`,
        textAlign: descAlign ? descAlign : 'center',
      }
    },
  },
  methods: {
    //跳转
    jumpUrl(item) {
      commonClickFn(item, {
        showContentType: 0, // 都没用
        showReadFlag: 0, // 都没用
        showPublishFlag: 0 // 都没用
      }, this, true)
    },

    // 数组处理
    getImageInfoList(articleDataList) {
      let idList = []
      articleDataList.map((item) => {
        idList.push(item.articleId)
      })
      this.$apis.cms.getImageList(idList).then(res => {
        // let imageInfoList = []
        let ImageInfoList = res.data
        articleDataList.map((item, index) => {
          // ImageInfoList[index] && (item.entryImg = ImageInfoList[index].thumbnail)
          ImageInfoList[index] && (item.id = ImageInfoList[index].id)
        })
      })
    },
    getShare(configObj) {
      const ourl = window.location.href.split('#')[0];
      var shlink = configObj.link || window.location.href.split('#')[0]
      api.share.getShareConfig({ url: ourl }).then((res) => {
        if (res.success) {
          window.wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timeStamp,
            nonceStr: res.data.nonce,
            signature: res.data.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'checkJsApi'],
            openTagList: ['wx-open-launch-app'],
          })

          window.wx.ready(function () {
            window.wx.checkJsApi({
              jsApiList: ['wx-open-launch-app', 'updateAppMessageShareData'],
              success: function (res) {
                console.log('可用',res)
              },
              fail: (err) => {
                console.log(err, '不可用')
              },
            })
            //分享朋友以及qq
            window.wx.updateAppMessageShareData({
              title: configObj.title, // 分享标题
              desc: configObj.desc, // 分享描述
              link: shlink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: configObj.imgUrl, // 分享图标
              success: function () {
                // 用户点击了分享后执行的回调函数
                console.log('成功')
                // $.post("$ctx/activity/shareCount.do",{"unionid":"$!unionid"},function(){});
              },
              complete() {
                console.log(434343);
              }
            })
            //分享朋友圈以及空间
            window.wx.updateTimelineShareData({
              title: configObj.title, // 分享标题
              link: shlink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: configObj.imgUrl, // 分享图标
              success: function () {
                // 用户点击了分享后执行的回调函数
                console.log('成功')
                // $.post("$ctx/activity/shareCount.do",{"unionid":"$!unionid"},function(){});
              },
            })
          })
        }
      })
    }
  },
  created() {
    // if (this.specialEntry) {
    //   this.getImageInfoList(this.specialEntry)
    // }
    // this.getShare({
    //   imgUrl:
    //     "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-mini/app_logo.png",
    //   title: '测试123',
    //   desc: "点击查看详情123",
    //   link: `${window.location.href}`,
    // })
  }
};
</script>
<style lang="less" scoped>
.image-content-root {
  margin-bottom: -1vh;
}
.picture-article-container {
  // display: flex;
  position: relative;
  //padding: 48px 24px 64px;
  box-sizing: border-box;
  .picture-article-title {
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    position: relative;
    height: 44px;
    font-size: 32px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 44px;
    z-index: 2;
    word-break: break-all;
  }

  .picture-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 6;
  }

  .coverImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 5;
  }

  .bg-opacity {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    //&:after{
    //  content: '';
    //  position: absolute;
    //  top: 0;
    //  left: 0;
    //  width: 100%;
    //  height: 100%;
    //  //background: rgba(0,0,0,0.6);
    //  z-index: 5;
    //}
  }

  .picture-article-img {
    //position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    box-sizing: border-box;
  }

  .picture-article-content {
    position: relative;
    margin-top: 24px;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
    z-index: 2;
    word-break: break-all;
  }
}
</style>
